import { Box, Button, Typography } from '@mui/material'
import { addUsers } from 'api/management'
import { useAlert } from 'hooks/useDialog'
import useLeavingPrompt from 'hooks/useLeavingPrompt'
import { useForm, FormProvider } from 'react-hook-form'
import { useNavigate, Link } from 'react-router-dom'

import UserFormFields, { AddFormData } from './UserFormFields'

const DEFAULT_VALUES: Readonly<AddFormData> = {
  name: '',
  email: '',
  concurID: '',
  authority: 'register',
  subGroups: [],
}

export default function UsersNew() {
  const alert = useAlert()
  const navigate = useNavigate()
  const methods = useForm<AddFormData>({
    defaultValues: DEFAULT_VALUES,
  })
  const { isDirty, isSubmitted, isSubmitting } = methods.formState

  useLeavingPrompt({
    message: ['登録をキャンセルします', '入力したデータは保存されません。'],
    when: isDirty && !(isSubmitted || isSubmitting),
  })

  const onSubmit = async (data: AddFormData) => {
    try {
      const result = (await addUsers([data])).results[0]
      if (result.status !== 'OK') {
        if (result.message === 'existing user') {
          throw new Error('existing user')
        }
        throw new Error('failed')
      }
      alert({ message: ['登録完了', 'ユーザーが登録されました'] })
      navigate('..')
    } catch (e: any) {
      if (e.message === 'existing user') {
        alert({ message: ['登録失敗', 'ユーザーが重複しています'] })
      } else {
        alert({ message: ['登録失敗', 'ユーザー登録に失敗しました'] })
      }
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <Box display="flex" justifyContent="space-between">
          <Typography component="h3" variant="h6">
            新規登録
          </Typography>
          <Box display="flex">
            <Button
              component={Link}
              variant="outlined"
              color="secondary"
              to=".."
              data-testid="cancel-button"
            >
              キャンセル
            </Button>
            <Button type="submit" variant="contained" color="primary" data-testid="save-button">
              保存
            </Button>
          </Box>
        </Box>
        <UserFormFields />
      </form>
    </FormProvider>
  )
}
